module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": "dense",
      "nav": "nav"
    }
  }, [(_vm.procesos && !_vm.procesos.length) ? _c('div', {
    staticClass: "d-flex fd-column flex-1"
  }, _vm._l((3), function(a) {
    return _c('div', [_c('v-skeleton-loader', {
      attrs: {
        "type": "list-item-avatar-two-line"
      }
    }), _c('v-skeleton-loader', {
      attrs: {
        "type": "divider"
      }
    })], 1)
  }), 0) : _vm._l((_vm.procesos), function(o, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          o.done && _vm.downloadFile(o)
        }
      }
    }, [_c('v-list-item-avatar', [(!o.done && !o.error) ? _c('v-progress-circular', {
      attrs: {
        "indeterminate": "",
        "color": "primary",
        "width": 3
      }
    }) : _vm._e(), (o.done) ? _c('v-icon', {
      staticClass: "background success--text"
    }, [_vm._v("check_circle")]) : (o.error) ? _c('v-icon', {
      staticClass: "background error--text"
    }, [_vm._v("close")]) : _vm._e()], 1), _c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "font-size-12"
    }, [_vm._v(_vm._s(o.name))]), (o.done) ? _c('v-list-item-subtitle', {
      staticClass: "text-muted font-size-11"
    }, [_vm._v("Terminó en  " + _vm._s(o.time))]) : (o.error) ? _c('v-list-item-subtitle', {
      staticClass: "font-size-11 error--text"
    }, [_vm._v("Error: " + _vm._s(o.message))]) : (!o.done && !o.error) ? _c('v-list-item-subtitle', {
      staticClass: "font-size-11 info--text"
    }, [_vm._v("Exportando...")]) : _vm._e()], 1), _c('v-list-item-action', [_c('div', {
      staticClass: "d-flex"
    }, [_c('v-btn', {
      attrs: {
        "disabled": !o.done,
        "fab": "fab",
        "color": "info white--text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.downloadFile(o)
        }
      }
    }, [_c('v-icon', [_vm._v(" arrow_downward")])], 1), _c('v-btn', {
      staticClass: "ml-3",
      attrs: {
        "disabled": !o.done,
        "fab": "fab",
        "color": "white error--text"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.eliminar(o.id)
        }
      }
    }, [_c('v-icon', [_vm._v(" delete")])], 1)], 1)])], 1)
  }), _c('div', {
    staticClass: "d-flex ma-2 mt-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "error",
      "block": "block",
      "small": !_vm.isMovil,
      "loading": !_vm.procesos.length,
      "disabled": !_vm.procesos.length
    },
    on: {
      "click": function($event) {
        return _vm.eliminarTodasLasDescargas()
      }
    }
  }, [_vm._v("Eliminar  descargas")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a08422","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_procesos_handler.vue
// module id = 512
// module chunks = 1